import { DepartmentModel } from "./department.model";

export class CityModel {
  cityId: number = 0;
  departmentId: number = 0;
  department: DepartmentModel | null = null;
  code: string = '';
  name: string = '';
}
